/** Risk level codes mapped to Norwegian labels. */
export const riskLevelsNb: Record<string, string> = {
  low: "Lav",
  medium: "Middels",
  high: "Høy",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const riskLevelOptionsNb: Array<{ code: string; name: string }> = Object.entries(riskLevelsNb).map(
  ([code, name]) => ({
    code,
    name,
  }),
)
